import { render } from "./AlertDetailPoVi.vue?vue&type=template&id=22739214&scoped=true&ts=true"
import script from "./AlertDetailPoVi.vue?vue&type=script&lang=ts"
export * from "./AlertDetailPoVi.vue?vue&type=script&lang=ts"

import "./AlertDetailPoVi.vue?vue&type=style&index=0&id=22739214&scoped=true&lang=css"

import exportComponent from "/srv/zpp/var/code/p-kunden.nsl.software/node-kunden-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22739214"]])

export default __exports__